import React, { Component } from 'react'
import TextWithFieldname from '../texts/TextWithFieldname';

class ResultError extends Component {

    render() {
        const errorWarningClassName = this.props.responseObject && this.props.responseObject.error != null
            && this.props.responseObject.error.criticality === 'WARNING' ? 'warning' : 'danger';
        return (
            <React.Fragment>
                {this.props.responseObject && (this.props.responseObject.hasError || this.props.responseObject.error != null)
                    && <React.Fragment>
                        {this.props.settings.process !== 'vehiclesConfig' && this.props.settings.process !== 'vehiclesStock'
                            && this.props.settings.process !== 'vehiclesDefault'
                            && this.props.vehicle && this.props.vehicle.presentation
                            && this.props.responseObject.hasError
                            && <React.Fragment>
                                <div>
                                    {this.props.vehicle.presentation.logo && this.props.vehicle.presentation.logo.trim() !== '' &&
                                        <img src={this.props.vehicle.presentation.logo} height="45"
                                            alt={this.props.vehicle.presentation.longLabel} />
                                    }
                                    <h6>{this.props.vehicle.presentation.longLabel}</h6>
                                </div>
                            </React.Fragment>
                        }
                        {this.props.responseObject.error == null
                            && <div className="row border round text-danger">
                                <TextWithFieldname fieldname="hasError" developperView={this.props.settings.isDevelopperView}
                                    variant="fs-5">An error occured</TextWithFieldname>
                            </div>}
                        {this.props.responseObject.error != null
                            &&
                            <div className={`row border round text-${errorWarningClassName}`} >
                                <TextWithFieldname fieldname="error.code" developperView={this.props.settings.isDevelopperView}
                                    variant="fs-5">Error code {this.props.responseObject.error.code}</TextWithFieldname>
                                <TextWithFieldname fieldname="error.technicalMessage"
                                    developperView={this.props.settings.isDevelopperView} variant="fs-6">
                                    {this.props.responseObject.error.technicalMessage}
                                </TextWithFieldname>
                                {this.props.responseObject.error.userMessage != null &&
                                    <TextWithFieldname fieldname="error.userMessage"
                                        developperView={this.props.settings.isDevelopperView} variant="fs-6">
                                        {this.props.responseObject.error.userMessage}
                                    </TextWithFieldname>
                                }
                            </div>
                        }
                    </React.Fragment>
                }
            </React.Fragment>
        )
    }

}

export default (ResultError)
